function Services() {
  return (
    <div className="page-container">
      <h1>Services</h1>
    </div>
  );
}

export default Services;